import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { BreathingCircle } from '@/components/focus/BreathingCircle';
import { OnboardingStep, FadeUp } from './OnboardingStep';

interface StepSuccessProps {
  displayName: string;
  onComplete: () => void;
  isLoading: boolean;
}

export function StepSuccess({ displayName, onComplete, isLoading }: StepSuccessProps) {
  return (
    <OnboardingStep>
      <FadeUp delay={0.2}>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight mb-6">
          You're all set, {displayName}.
        </h1>
      </FadeUp>
      
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.5, duration: 0.6, type: "spring" }}
        className="mb-10"
      >
        <div className="relative w-[160px] h-[160px] flex items-center justify-center">
          <BreathingCircle variant="focus" />
        </div>
      </motion.div>
      
      <FadeUp delay={0.8}>
        <p className="text-lg text-muted-foreground mb-16 max-w-sm">
          Your journey to focused productivity begins now.
        </p>
      </FadeUp>
      
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.1, duration: 0.5 }}
        className="w-full mt-4"
      >
        <Button
          size="lg"
          onClick={onComplete}
          disabled={isLoading}
          className="w-full h-14 text-lg font-medium"
        >
          {isLoading ? 'Setting up...' : 'Continue'}
        </Button>
      </motion.div>
    </OnboardingStep>
  );
}
